import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Link } from 'react-router';
import {titleToId} from 'utils/url-rewrite';

import Ordinal from 'modules/Common/components/Ordinal';

import {LocalTimeShort} from 'modules/Common/components/LocalDateTime';

require('./GreyhoundRacingFastResult.scss');

export default class GreyhoundRacingFastResult extends Component {
  static propTypes = {
    data: PropTypes.shape({
      top_greyhounds: PropTypes.arrayOf(PropTypes.object),
      winning_trainer: PropTypes.object,
      courseName: PropTypes.string,
      status: PropTypes.string,
      time: PropTypes.string,
      off_time: PropTypes.string,
      straight_forecast: PropTypes.string,
      tricast: PropTypes.string,
      slug: PropTypes.string
    })
  };

  constructor() {
    super();
    this.state = {expanded: false};
  }

  toggleExpanded() {
    this.setState({expanded: !this.state.expanded});
  }

  render() {
    const {data} = this.props;
    // currently taking from slug as it isn't supplied with API request
    const raceDate = data.slug.split('/')[0];
    const favToken = favGreyhoundsToken(data.top_greyhounds, data.unplaced_favourite);

    return (
      <div className="fast-racecard-item">
        <div className="fast-racecard-header">
          <div className="fast-racecard-header-race" id={titleToId(data.courseName)}>{data.time && <LocalTimeShort iso={`${raceDate}T${data.time}Z`} />} {data.courseName ? data.courseName : "Unknown"}</div>
          <div className="fast-racecard-header-fulllink">
            {data.status=="Final Result" ?
              <Link className="fast-racecard-header-fulllink-btn" to={"/greyhounds/racecards/" + data.slug}>Full results</Link>
            :
              <span className="fast-racecard-header-fulllink-btn">Full results</span>
            }
          </div>
        </div>
        {showTopGreyhounds(data) &&
          data.top_greyhounds.map(dog => (
            <div key={dog.greyhound_reference.id} className="fast-results-place">
              <div className="fast-results-place-position">
                <Ordinal n={dog.position}/>
              </div>
              <div className="fast-results-place-number">
                ({dog.saddlecloth_number})
              </div>
              <div className="fast-results-place-name">
                <span>{dog.greyhound_name}</span>
              </div>
              <div className="fast-results-place-odds">
                {dog.odds} {dog.favourite && favToken}
              </div>
            </div>
          ))
        }
        <ul className="fast-racecard-content fast-result-without-more-link">
          <OptionalData className="fast-racecard-content-top" value={(data.winning_trainer || {}).name}>Winning Trainer:</OptionalData>
          <OptionalData className="fast-racecard-content-top" value={data.off_time}>Off-Time:</OptionalData>
          <OptionalData className="fast-racecard-content-top" value={data.straight_forecast}>Forecast:</OptionalData>
          <OptionalData className="fast-racecard-content-top" value={data.tricast}>Tricast:</OptionalData>
          {data.status &&
            <li className="fast-result-status">
              <span className="fast-result-status-label">{data.status}</span>
            </li>}
        </ul>
      </div>
    );
  }
}

function showTopGreyhounds(data) {
  return data.status && (data.status==="Result" || data.status==="Final Result") && data.top_greyhounds && (data.top_greyhounds.length > 0);
}

function OptionalData(props) {
  return props.value
       ? (
           <li className={props.className}>
             <span className="fast-racecard-content-label">{props.children}</span>
             <span className="fast-racecard-content-value">{props.value}</span>
           </li>
         )
       : null;
}
OptionalData.propTypes = {
  className: PropTypes.string,
  value: PropTypes.any,
  children: PropTypes.node
};

function countFavGreyhounds(array) {
  var result = 0;
  if (array) {
    for (var i = 0; i < array.length; i++) {
      if (array[i].favourite === true) {
        result++;
      }
    }
  }
  return result;
}

function favGreyhoundsToken(arrayTop, arrayUnfav) {
  const sum = countFavGreyhounds(arrayTop) + countFavGreyhounds(arrayUnfav);
  if (sum == 1) {
    return "f";
  } else if (sum >= 2) {
    return "j";
  }
  return "";
}



// WEBPACK FOOTER //
// ./modules/GreyhoundRacing/components/GreyhoundRacingFastResult.js